import * as yup from 'yup';

const baseSchema = {
  year: yup.string().required(),
  month: yup.string().required(),
  day: yup.string().required(),
  startHour: yup.string().required(),
  startMinute: yup.string().required(),
  endHour: yup.string().required(),
  endMinute: yup.string().required(),
  numberOfPeople: yup.number().required().min(0),
  numberOfFacilities: yup.number().nullable().optional(),
  zip: yup.string().required(),
  prefecture: yup.string().required(),
  city: yup.string().required(),
  street: yup.string().required(),
  building: yup.string().nullable().optional(),
  hostingOfficeName: yup.string().nullable().optional(),
  couponCode: yup.string().nullable().optional(),
};

// レク種別に応じてスキーマを生成するファクトリー関数
// オンラインレクでは交通費・諸経費は表示されないため任意扱いにする
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createModalFormSchema = (isOnline: boolean) => {
  const expenseFields = isOnline
    ? {
        transportationExpenses: yup.number().nullable().optional(),
        expenses: yup.number().nullable().optional(),
      }
    : {
        transportationExpenses: yup
          .number()
          .typeError('交通費を入力してください')
          .required('交通費を入力してください')
          .min(0, '0以上の値を入力してください'),
        expenses: yup
          .number()
          .typeError('諸経費を入力してください')
          .required('諸経費を入力してください')
          .min(0, '0以上の値を入力してください'),
      };

  return yup.object().shape({ ...baseSchema, ...expenseFields });
};

export const newModalFormSchema = createModalFormSchema(false);

export const editModalFormSchema = createModalFormSchema(false);

export type ModalFormValues = yup.InferType<
  ReturnType<typeof createModalFormSchema>
>;
